import * as React from "react";
import { createRoot } from "react-dom/client";
import "./styles/variables.css";
import App from "./components/app/app";
import { ProductsProvider } from "./contexts/ProductsProvider";

createRoot(document.getElementById("root")).render(
  <ProductsProvider>
    <App />
  </ProductsProvider>,
);
